import * as TIModule from 'Modules/TerminalInstallationModule';
import {
    SetActive,
    SetTechnicianListAction,
    GetTerminalInstallationOrderSuccesAction,
    GetTerminalInstallationOrderWithFiltersSuccesAction,
    GetTerminalInstallationTotalCount,
    SetTerminallInstalationOneElement,
    GetTerminalInstallationOrderHistoryRequestAction,
    GetTerminalInstallationOrderHistorySuccesAction,
    SetTerminalInstallationOrderHistoryComments,
    GetTerminalInstallationOrderHistoryErrorAction,
    SetTerminalNotesListAction,
    UpdateTerminalNotesListAction
} from './Models/TerminalInstallationActionsModel';
import * as ActionTypes from './EnumTypes/ActionEnumTypes';
import {reset} from 'redux-form';
import * as ErrorActions from './../Actions/ErrorActions';
import {EnumTypes as ErrorEnumType} from 'Models/EnumTypes/ErrorEnumTypes';
import {history} from 'HelperFunctions/root';
import * as Dictionary from 'Models/Dictionary';
import i18n from 'Translations/_i18n';
import * as ViewManagementModule from 'Modules/ViewManagementModule';
import {saveAs} from 'file-saver';
import {Types as UserType} from '../../Models/UserModel';
import {store} from '../Store';
import {RootState} from 'Redux/Reducers/_RootReducer';
import moment from "moment";
import * as InfinityTableModule from "Modules/InfinityTableModule";
import {EnumTypes} from "Models/EnumTypes/TerminalInstallationEnumTypes";

/**
 * Klasa kreatora akcji dla zleceń montażu
 *
 * @export
 * @class TerminalInstallationActions
 */
export class TerminalInstallationActions {
    /**
     * Thank odpowiedzialny za pobranie listy zleceń montażu z serwera
     *
     * @static
     * @param {URLSearchParams} [queryParams]
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static getTerminalInstallationOrders(queryParams?: URLSearchParams, filterQuery?: boolean): Function {
        return async dispatch => {
            try {
                const response = await TIModule.Connector.getTerminalInstallationOrderList(queryParams);

                if (filterQuery) {
                    dispatch(this.getTerminalInstallationOrderWithFiltersSuccesAction(response.data.terminalInstallationOrder.results));
                } else {
                    dispatch(this.getTerminalInstallationOrderSuccesAction(response.data.terminalInstallationOrder.results));
                }

                //TODO: poniższy dispatch niepotrzebny, będzie można zastąpić tym z infinity tabeli. Do zrefatkrowoania w przyszłości.
                dispatch(this.getTerminalInstallationTotalCountSuccessAction(response.data.terminalInstallationOrder.totalCount));

                const terminalListNewLength = (store.getState() as RootState).terminalInstallationStore.terminalInstallationOrderList.length;
                dispatch(InfinityTableModule.Actions.setInfinityTableAllCounts(terminalListNewLength, response.data.terminalInstallationOrder.totalCount));

            } catch (err) {
                // console.log('error action', err);
                // dispatch(this.getTerminalInstallationOrdersFailure(err));
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getTerminalInstallationOrders.
     * Wykonywany gdy pobranie danych poprzez infinity scroll się powiodło
     *
     * @private
     * @static
     * @param {Array<TIModule.Types.TerminalInstallationOrderSimpleDto>} terminalInstallationOrderList
     * @returns {GetTerminalInstallationOrderSuccesAction}
     * @memberof TerminalInstallationActions
     */
    private static getTerminalInstallationOrderSuccesAction(terminalInstallationOrderList: Array<TIModule.Types.TerminalInstallationOrderSimpleDto>): GetTerminalInstallationOrderSuccesAction {
        return {
            type: ActionTypes.TerminalInstallation.GET_TERMINAL_INSTALLATION_ORDER_SUCCESS,
            payload: {
                terminalInstallationOrderList
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getTerminalInstallationOrders.
     * Wykonywany gdy pobranie danych Z FILTRAMI się powiodło
     *
     * @private
     * @static
     * @param {Array<TIModule.Types.TerminalInstallationOrderSimpleDto>} terminalInstallationOrderList
     * @returns {GetTerminalInstallationOrderWithFiltersSuccesAction}
     * @memberof TerminalInstallationActions
     */
    private static getTerminalInstallationOrderWithFiltersSuccesAction(terminalInstallationOrderList: Array<TIModule.Types.TerminalInstallationOrderSimpleDto>): GetTerminalInstallationOrderWithFiltersSuccesAction {
        return {
            type: ActionTypes.TerminalInstallation.GET_TERMINAL_INSTALLATION_ORDER_WITH_FILTERS_SUCCESS,
            payload: {
                terminalInstallationOrderList
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getTerminalInstallationOrders.
     * Wykonywany gdy pobranie danych się powiodło
     * Służy do zapisania calkowitej liczby rekordów danego query bez wzgledu na ilosc obecnie wyswietlanych (infinity scroll)
     */
    private static getTerminalInstallationTotalCountSuccessAction(terminalInstallationTotalCount: number): GetTerminalInstallationTotalCount {
        return {
            type: ActionTypes.TerminalInstallation.GET_TERMINAL_INSTALLATION_TOTAL_COUNT_SUCCESS,
            payload: {
                terminalInstallationTotalCount
            }
        };
    }

    /* getTerminalInstallationOrderHistory */
    public static getTerminalInstallationOrderHistory(index: number): Function {
        return async dispatch => {
            try {
                dispatch(this.setStatusHistoryLoader(TIModule.TerminalInstallationEnumTypes.HistoryRequestStatus.SHOW));
                //TODO:awaryne wydaje mnie się pobieranie to poprzez index - nieznalazłem nic z tego obiektu w event
                const terminalInstallationStore = (store.getState() as RootState).terminalInstallationStore;
                const terminalInstallationOrder = terminalInstallationStore.terminalInstallationOrderList[index];
                dispatch(this.setTerminalInstallationOrderHistoryComments(terminalInstallationOrder));
                const response = await TIModule.Connector.getTerminalInstallationOrderHistory(terminalInstallationOrder.id);
                dispatch(this.setTerminalInstallationOrderHistory(response.data.terminalInstallationOrderHistoryList));
            } catch (err) {
                dispatch(this.getTerminalInstallationOrderHistoryFailure());
            }
        };
    }

    public static setStatusHistoryLoader(status: TIModule.TerminalInstallationEnumTypes.HistoryRequestStatus): GetTerminalInstallationOrderHistoryRequestAction {
        return {
            type: ActionTypes.TerminalInstallation.SET_STATUS_HISTORY_LOADER,
            payload: {
                status
            }
        };
    }

    public static setTerminalInstallationOrderHistory(terminalInstallationOrderHistory: Array<TIModule.Types.TerminalInstallationOrderHistory>): GetTerminalInstallationOrderHistorySuccesAction {
        return {
            type: ActionTypes.TerminalInstallation.SET_HISTORY_SUCCESS,
            payload: {
                terminalInstallationOrderHistory
            }
        };
    }

    public static setTerminalInstallationOrderHistoryComments(terminalInstallationOrder: TIModule.Types.TerminalInstallationOrderSimpleDto): SetTerminalInstallationOrderHistoryComments {
        return {
            type: ActionTypes.TerminalInstallation.SET_HISTORY_COMMENTS,
            payload: {
                terminalInstallationOrder
            }
        };
    }

    public static getTerminalInstallationOrderHistoryFailure(): GetTerminalInstallationOrderHistoryErrorAction {
        return {
            type: ActionTypes.TerminalInstallation.SET_HISTORY_ERROR
        };
    }

    /**
     * Generator akcji zwraca akcje ustawiającą aktywne zlecenie montażu
     *
     * @static
     * @param {number} id
     * @returns {SetActive}
     * @memberof TerminalInstallationActions
     */
    public static setActive(id: number): SetActive {
        return {
            method: 'setActiveAction',
            type: ActionTypes.TerminalInstallation.SET_ACTIVE,
            payload: {
                id
            }
        };
    }

    /**
     * Thank odpowiedzialny za utworzenie zlecenia montażu
     *
     * @static
     * @param {TIModule.Types.CreateTerminalInstallationRequest} formDate
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static createTerminalInstallationOrder(formDate: TIModule.Types.CreateTerminalInstallationRequest): Function {
        return async dispatch => {
            try {
                await TIModule.Connector.createTerminalInstallationOrder(formDate);
                dispatch(reset('terminalInstallationListAddForm'));
                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumType.NewsType.SUCCESS,
                    message: i18n.t('forms:createTerminalInstallationOrderSucces')
                }));
                const {TERMINAL_INSTALLATION} = ViewManagementModule.EnumTypes.Page;
                history.push(`${Dictionary.PageUrl.get(TERMINAL_INSTALLATION)}`);
            } catch (err) {
                //console.log(err);
            }
        };
    }

    /**
     * Thank odpowiedzialny za edycje zlecenia montażu
     *
     * @static
     * @param {TIModule.Types.CreateTerminalInstallationRequest} formDate
     * @param {number} id
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static editTerminallInstalationOrder(formDate: TIModule.Types.EditTerminalInstallationRequest, id: number): Function {
        return async (dispatch) => {
            try {
                dispatch(ViewManagementModule.Actions.showLoader());
                if (formDate.status === TIModule.TerminalInstallationEnumTypes.Status.INSTALLATION_CONFIRMED) {
                    const vinPhotosFormData = new FormData()
                    if (formDate.vinPhoto instanceof File) {
                        vinPhotosFormData.append('file', formDate.vinPhoto)
                    }

                    const frontPhotosFormData = new FormData()
                    if (formDate.frontPhoto instanceof File) {
                        frontPhotosFormData.append('file', formDate.frontPhoto)
                    }

                    const backPhotosFormData = new FormData()
                    if (formDate.backPhoto instanceof File) {
                        backPhotosFormData.append('file', formDate.backPhoto)
                    }

                    const dashboardPhotosFormData = new FormData()
                    if (formDate.dashboardPhoto instanceof File) {
                        dashboardPhotosFormData.append('file', formDate.dashboardPhoto)
                    }

                    await Promise.all([
                       TIModule.Connector.updateTerminalInstallationVin(id, formDate.vin),
                       TIModule.Connector.editTerminalInstallationOrder(formDate, id),
                       vinPhotosFormData.has('file') && TIModule.Connector.updateTerminalInstallationPhotos(id, vinPhotosFormData, EnumTypes.CarPictureType.VIN),
                       dashboardPhotosFormData.has('file') && TIModule.Connector.updateTerminalInstallationPhotos(id, dashboardPhotosFormData, EnumTypes.CarPictureType.DASHBOARD),
                       backPhotosFormData.has('file') && TIModule.Connector.updateTerminalInstallationPhotos(id, backPhotosFormData, EnumTypes.CarPictureType.CAR_BACK),
                       frontPhotosFormData.has('file') && TIModule.Connector.updateTerminalInstallationPhotos(id, frontPhotosFormData, EnumTypes.CarPictureType.CAR_FRONT),
                    ])
                } else {
                    delete formDate.status
                    delete formDate.vinPhoto
                    delete formDate.frontPhoto
                    delete formDate.backPhoto
                    delete formDate.dashboardPhoto
                    await TIModule.Connector.editTerminalInstallationOrder(formDate, id);
                }

                dispatch(reset('terminalInstallationListAddForm'));
                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumType.NewsType.SUCCESS,
                    message: i18n.t('forms:updateTerminalInstallationOrderSucces')
                }));
                const {TERMINAL_INSTALLATION} = ViewManagementModule.EnumTypes.Page;
                history.push(`${Dictionary.PageUrl.get(TERMINAL_INSTALLATION)}`);
            } catch (err) {
                //console.log(err);
            } finally {
                dispatch(ViewManagementModule.Actions.hideLoader());
            }
        };
    }

    /**
     * Thank odpowiedzialny za pobranie pojedyńczego zlecenia z serwera
     *
     * @static
     * @param {number} terminallInstalationId
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static getTerminallInstalationById(terminallInstalationId: number): Function {
        return async dispatch => {
            try {
                const response = await TIModule.Connector.getTerminalInstallationOrderById(terminallInstalationId);
                dispatch(this.setTerminallInstalationOneElement(response.data.terminalInstallationOrder));
            } catch (err) {
                //console.log(err);
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getTerminallInstalationById
     * Generuje akcje która ustawia pojedyńcze zlecenie w store
     *
     * @static
     * @param {TIModule.Types.TerminalInstallationOrderDto} terminaInstalationDto
     * @returns {SetTerminallInstalationOneElement}
     * @memberof TerminalInstallationActions
     */
    public static setTerminallInstalationOneElement(terminaInstalationDto: TIModule.Types.TerminalInstallationOrderDto): SetTerminallInstalationOneElement {
        return {
            type: ActionTypes.TerminalInstallation.SET_TERMINAL_INSTALLATION_ONE_ELEMENT,
            payload: {
                terminalInstallationOneElement: terminaInstalationDto
            }
        };
    }

    /**
     * Thank odpowiedzialny za ustawienie daty montażu terminala w zleceniu montażu
     *
     * @static
     * @param {TIModule.Types.SetDateTerminalInstallationRequest} formDate
     * @param {number} id
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static setDateTerminallInstalationOrder(formDate: TIModule.Types.SetDateTerminalInstallationRequest, id: number): Function {
        return async dispatch => {
            try {
                await TIModule.Connector.setDateTerminalInstallation(formDate, id);
                dispatch(reset('terminalInstallationListSetDateForm'));

                dispatch(ErrorActions.setNewsForMoment({
                    type: ErrorEnumType.NewsType.SUCCESS,
                    message: i18n.t('forms:setDateTerminalInstallationOrderSucces')
                }));

                const {TERMINAL_INSTALLATION} = ViewManagementModule.EnumTypes.Page;
                history.push(`${Dictionary.PageUrl.get(TERMINAL_INSTALLATION)}`);
            } catch (err) {
                //console.log(err);
            }
        };
    }

    /**
     * Thank odpowiedzialny za anulowanie zlecenia montażu
     *
     * @static
     * @param {number} terminalInstallationOrdersId
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static cancelTerminalInstallationOrders(terminalInstallationOrdersId: number): Function {
        return async dispatch => {
            try {
                await TIModule.Connector.cancelTerminalInstallationOrders(terminalInstallationOrdersId);
                dispatch(this.getTerminalInstallationOrders());
            } catch (err) {
                //gg
            }
        };
    }

    /**
     * Thank odpowiedzialny za potwierdzenie zainstalowania terminalu
     *
     * @static
     * @param {number} terminalInstallationOrdersId
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static confirmTerminalInstallation(terminalInstallationOrdersId: number): Function {
        return async dispatch => {
            try {
                await TIModule.Connector.confirmTerminalInstallation(terminalInstallationOrdersId);
                dispatch(this.getTerminalInstallationOrders());
            } catch (err) {
                //gg
            }
        };
    }

    /**
     * Thank odpowiedzialny za anulowanie daty zaplanowej instalacji terminalu
     *
     * @static
     * @param {number} terminalInstallationOrdersId
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static cancelInstallationDate(terminalInstallationOrdersId: number): Function {
        return async dispatch => {
            try {
                await TIModule.Connector.cancelInstallationDate(terminalInstallationOrdersId);
                dispatch(ViewManagementModule.Actions.showLoader());
                await dispatch(this.getTerminalInstallationOrders(null, true));
                dispatch(ViewManagementModule.Actions.hideLoader());
            } catch (err) {
                //gg
            }
        };
    }

    /**
     * Thank odpowiedzialny za pobranie do użytkownika sprawozdania z montażu
     *
     * @static
     * @param {number} terminalInstallationId
     * @returns {Function}
     * @memberof TerminalInstallationActions
     */
    public static getTerminalInstallationReportFile(terminalInstallationId: number): Function {
        return async dispatch => {
            try {
                dispatch(ViewManagementModule.Actions.showDetailsSidebarLoader());
                const reportFileResponse = await TIModule.Connector.getTerminalInstallationReportFile(terminalInstallationId);
                const blob = reportFileResponse.data;
                const contentDisposition = reportFileResponse.headers['content-disposition'];
                let name = `terminal-installation-report-${terminalInstallationId}.pdf`;
                if (contentDisposition) {
                    const match = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (match && match[1]) {
                        name = match[1].replace(/['"]+/g, '');
                    }
                }
                saveAs(blob, name);
                dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
            } catch (err) {
                dispatch(ViewManagementModule.Actions.hideDetailsSidebarLoader());
            }
        };
    }

    /**
     * Thank odpowiedzialny za pobranie listy monterów
     *
     * @static
     * @param {URLSearchParams} [queryParams]
     * @returns
     * @memberof TerminalInstallationActions
     */
    public static getTechnicianList(queryParams?: URLSearchParams) {
        return async dispatch => {
            try {
                const userList = await TIModule.Connector.getTechnicianList(queryParams ? queryParams : null);
                dispatch(this.getTechnicianListSuccess(userList.data.userList));
            } catch (err) {
                //gg
            }
        };
    }

    /**
     * Generator akcji powiązany z thank getTechnicianList
     * Generuje akcje która ustawia w stor liste monterów
     *
     * @private
     * @static
     * @param {Array<UserType.UserDto>} technicians
     * @returns {SetTechnicianListAction}
     * @memberof TerminalInstallationActions
     */
    private static getTechnicianListSuccess(technicians: Array<UserType.UserDto>): SetTechnicianListAction {
        return {
            type: ActionTypes.TerminalInstallation.SET_TECHNICIAN_LIST,
            payload: {
                technicians
            }
        };
    }

    /**
     * Thank odpowiedzialny za dodanie notatki do zlecenia
     *
     * @static
     * @param {URLSearchParams} [queryParams]
     * @returns
     * @memberof TerminalInstallationActions
     */
    public static addNote(index: number, note: string) {
        return async dispatch => {
            try {
                await TIModule.Connector.setTerminalInstallationNote(index, note);
                const {firstName, lastName} = (store.getState() as RootState).userStore.user;
                const tmpNote: TIModule.Types.TerminalInstallationNote = {
                    authorFirstName: firstName,
                    authorLastName: lastName,
                    comment: note,
                    creationDate: moment().format(),
                    id: -1
                }
                dispatch(this.addNoteSuccess(tmpNote));
            } catch (err) {
                console.log(err);
            }
        };
    }

    /**
     * Generator akcji powiązany z thank addNote
     * Generuje akcje która ustawia w store liste notatek powięksoną o tę własnie dodaną
     */
    private static addNoteSuccess(note: TIModule.Types.TerminalInstallationNote): UpdateTerminalNotesListAction {
        return {
            type: ActionTypes.TerminalInstallation.UPDATE_TERMINAL_NOTES_LIST,
            payload: {
                note
            }
        };
    }

    public static getTerminalInstallationNotes(index: number): Function {
        return async dispatch => {
            try {
                const response = await TIModule.Connector.getTerminalInstallationNotes(index);
                dispatch(this.getTerminalInstallationNotesSuccess(response.data.comments));
            } catch (err) {
                console.log(err);
            }
        };
    }

    private static getTerminalInstallationNotesSuccess(notes: Array<TIModule.Types.TerminalInstallationNote>): SetTerminalNotesListAction {
        return {
            type: ActionTypes.TerminalInstallation.SET_TERMINAL_NOTES_LIST,
            payload: {
                notes
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Actions/TerminalInstallationActions.ts